import './App.css';

import {Routes, Route} from 'react-router-dom';
import Landing from './Components/Landing';
import Contact from './Components/Contact';
import Service from './Components/Services.jsx';
import Produits from './Components/Produits';
import SingleProduct from './Components/SingleProduct.jsx';
import AdminDashboard from './Components/AdminDashboard.jsx';
import AdminLogin from './Components/AdminLogin.jsx';
import ScrollToTop from "./Components/ScrollToTop.jsx";
import SearchResults from './Components/SearchResults.jsx';

function App() {

  

  return (
    <div className="App">
      
    <ScrollToTop />
      <Routes>
     <Route path='/' element = {<Landing/>}></Route>
     <Route path='/contact' element = {<Contact/>}></Route>
     <Route path='/services' element = {<Service/>}></Route>
     <Route path='/produits' element = {<Produits/>}></Route>
       <Route path="/produits/:id" element={<SingleProduct />} />
        <Route path='/admin/login' element={<AdminLogin />} /> 
        <Route path='/admin/dashboard' element={<AdminDashboard />} />
        <Route path="/recherche" element={<SearchResults />} />
      </Routes>
      </div>
      
)}
export default App